'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var errCode = require('err-code');

var ipfsUnixfs = require('ipfs-unixfs');

var persist = require('../../utils/persist.js');

var dagPb = require('@ipld/dag-pb');

var parallelBatch = require('it-parallel-batch');

var rawCodec = require('multiformats/codecs/raw');

var flat = require('./flat.js');

var balanced = require('./balanced.js');

var trickle = require('./trickle.js');

var bufferImporter = require('./buffer-importer.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var dagPb__namespace = /*#__PURE__*/_interopNamespace(dagPb);

var parallelBatch__default = /*#__PURE__*/_interopDefaultLegacy(parallelBatch);

var rawCodec__namespace = /*#__PURE__*/_interopNamespace(rawCodec);

var dagBuilders = {
  flat: flat,
  balanced: balanced,
  trickle: trickle
};

function buildFileBatch(_x, _x2, _x3) {
  return _buildFileBatch.apply(this, arguments);
}

function _buildFileBatch() {
  _buildFileBatch = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, blockstore, options) {
    var count, previous, bufferImporter$1, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            count = -1;

            if (typeof options.bufferImporter === 'function') {
              bufferImporter$1 = options.bufferImporter;
            } else {
              bufferImporter$1 = bufferImporter;
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 4;
            _iterator = _asyncIterator(parallelBatch__default['default'](bufferImporter$1(file, blockstore, options), options.blockWriteConcurrency));

          case 6:
            _context.next = 8;
            return _awaitAsyncGenerator(_iterator.next());

          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 25;
              break;
            }

            entry = _step.value;
            count++;

            if (!(count === 0)) {
              _context.next = 16;
              break;
            }

            previous = entry;
            return _context.abrupt("continue", 22);

          case 16:
            if (!(count === 1 && previous)) {
              _context.next = 20;
              break;
            }

            _context.next = 19;
            return previous;

          case 19:
            previous = null;

          case 20:
            _context.next = 22;
            return entry;

          case 22:
            _iteratorAbruptCompletion = false;
            _context.next = 6;
            break;

          case 25:
            _context.next = 31;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 31:
            _context.prev = 31;
            _context.prev = 32;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 36;
              break;
            }

            _context.next = 36;
            return _awaitAsyncGenerator(_iterator.return());

          case 36:
            _context.prev = 36;

            if (!_didIteratorError) {
              _context.next = 39;
              break;
            }

            throw _iteratorError;

          case 39:
            return _context.finish(36);

          case 40:
            return _context.finish(31);

          case 41:
            if (!previous) {
              _context.next = 45;
              break;
            }

            previous.single = true;
            _context.next = 45;
            return previous;

          case 45:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _buildFileBatch.apply(this, arguments);
}

var reduce = function reduce(file, blockstore, options) {
  function reducer(_x4) {
    return _reducer.apply(this, arguments);
  }

  function _reducer() {
    _reducer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(leaves) {
      var leaf, _buffer, f, links, node, buffer, cid;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(leaves.length === 1 && leaves[0].single && options.reduceSingleLeafToSelf)) {
                _context2.next = 13;
                break;
              }

              leaf = leaves[0];

              if (!(leaf.cid.code === rawCodec__namespace.code && (file.mtime !== undefined || file.mode !== undefined))) {
                _context2.next = 12;
                break;
              }

              _context2.next = 5;
              return blockstore.get(leaf.cid);

            case 5:
              _buffer = _context2.sent;
              leaf.unixfs = new ipfsUnixfs.UnixFS({
                type: 'file',
                mtime: file.mtime,
                mode: file.mode,
                data: _buffer
              });
              _buffer = dagPb.encode(dagPb.prepare({
                Data: leaf.unixfs.marshal()
              }));
              _context2.next = 10;
              return persist(_buffer, blockstore, _objectSpread(_objectSpread({}, options), {}, {
                codec: dagPb__namespace,
                hasher: options.hasher,
                cidVersion: options.cidVersion
              }));

            case 10:
              leaf.cid = _context2.sent;
              leaf.size = _buffer.length;

            case 12:
              return _context2.abrupt("return", {
                cid: leaf.cid,
                path: file.path,
                unixfs: leaf.unixfs,
                size: leaf.size
              });

            case 13:
              f = new ipfsUnixfs.UnixFS({
                type: 'file',
                mtime: file.mtime,
                mode: file.mode
              });
              links = leaves.filter(function (leaf) {
                if (leaf.cid.code === rawCodec__namespace.code && leaf.size) {
                  return true;
                }

                if (leaf.unixfs && !leaf.unixfs.data && leaf.unixfs.fileSize()) {
                  return true;
                }

                return Boolean(leaf.unixfs && leaf.unixfs.data && leaf.unixfs.data.length);
              }).map(function (leaf) {
                if (leaf.cid.code === rawCodec__namespace.code) {
                  f.addBlockSize(leaf.size);
                  return {
                    Name: '',
                    Tsize: leaf.size,
                    Hash: leaf.cid
                  };
                }

                if (!leaf.unixfs || !leaf.unixfs.data) {
                  f.addBlockSize(leaf.unixfs && leaf.unixfs.fileSize() || 0);
                } else {
                  f.addBlockSize(leaf.unixfs.data.length);
                }

                return {
                  Name: '',
                  Tsize: leaf.size,
                  Hash: leaf.cid
                };
              });
              node = {
                Data: f.marshal(),
                Links: links
              };
              buffer = dagPb.encode(dagPb.prepare(node));
              _context2.next = 19;
              return persist(buffer, blockstore, options);

            case 19:
              cid = _context2.sent;
              return _context2.abrupt("return", {
                cid: cid,
                path: file.path,
                unixfs: f,
                size: buffer.length + node.Links.reduce(function (acc, curr) {
                  return acc + curr.Tsize;
                }, 0)
              });

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _reducer.apply(this, arguments);
  }

  return reducer;
};

function fileBuilder(file, block, options) {
  var dagBuilder = dagBuilders[options.strategy];

  if (!dagBuilder) {
    throw errCode__default['default'](new Error("Unknown importer build strategy name: ".concat(options.strategy)), 'ERR_BAD_STRATEGY');
  }

  return dagBuilder(buildFileBatch(file, block, options), reduce(file, block, options), options);
}

module.exports = fileBuilder;